import global from "@/global";

const get = (hideIfProduction = true) => {
    const appSettings = global.getAppSettings();
    const hostname = document.location.hostname.toLowerCase();

    if (hideIfProduction && hostname === appSettings.hostname) {
        return "";
    }
    
    if (hostname.startsWith("localhost")) {
        return "localhost";
    }

    const match = /^(?<env>[a-z0-9][a-z0-9\-.]+?[a-z0-9])(\.sharedo\.co\.uk)?$/.exec(hostname);
    if (match) {
        return match.groups.env;
    }

    return "";
}

export default {
    get,
}